export default function PhoneMockup({ src, alt, className = "", testid, width = "max-w-[270px]" }) {
  return (
    <div
      data-testid={testid}
      className={`relative mx-auto w-full ${width} rounded-[2.4rem] border border-[#2C2E29] bg-[#1C1D1A] p-2 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.8)] ${className}`}
    >
      <div className="overflow-hidden rounded-[1.9rem] bg-[#121311]">
        <img src={src} alt={alt} loading="lazy" className="block h-auto w-full" />
      </div>
    </div>
  );
}
